import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import AppPage from '../../../Core/AppPage';
import './donor-applications-page.scss';
import Globe from '../../../Components/SVG/Globe';
import KaleidoscopeAPI from '../../../Core/KaleidoscopeAPI';
import InfoBanner from '../../../Components/InfoBanner/InfoBanner';
import Eyes from '../../../Components/SVG/Eyes';
import Bolt from '../../../Components/SVG/Bolt';
import Score from '../../../Components/SVG/Score';
import ApplicationStatusChange from '../../../Components/ApplicationStatusChange/ApplicationStatusChange';
import { DateTime } from 'luxon';
import TabbedTablePage from '../../../Components/TabbedTablePage/TabbedTablePage';
import Loader from '../../../Components/Loader/Loader';
import { applicationIsLoading } from '../../../Core/applicationIsLoading'
import { MAIN_CONFIG } from '../../../../config/main';
import { reduxPage } from '../../../Core/store'
import { useRouter } from 'next/router';
import SweetAlert from 'react-bootstrap-sweetalert';
import FlashMessage from '../../../Components/FlashMessage/Message';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { backButtonClicked } from '../../../hooks/currenttabIndexAction';
import Field from '../../../Components/Field/Field';
import ApplicationAwardUpdate from '../../../Components/ApplicationAwardUpdate/ApplicationAwardUpdate';
import ApplicationScanResult from '../../../Components/ApplicationScanResult/ApplicationScanResult';
import Alert from '../../../Components/SVG/Alert';
import UniversityOfAlaskaAward from '../../../Components/UniversityOfAlaskaAward/UniversityOfAlaskaAward';
import TagManager from 'react-gtm-module';


const { USER_CONTEXT } = MAIN_CONFIG;

export const DonorApplications = (
    {
        pageData,
        accountData,
        setShowTableActionBar,
        setTableActionBarNumSelected,
        setTableActionBarNumTotal,
        setActiveHeaderNav,
        setReviewersScreenState,
        reviewersScreenState,
        userContext,
        setSelectedRows,
        setRemoveRows,
        setSelectedRowsAll,
        setCurrentSearchTermsScholarship,
        setCurrentSearchKeyScholarship,
        setActiveTabTable,
        setModalState,
        reviewersCount,
        showTableActionBar = false,
        setShowApplicationsSidebar,
        pageType,
        tableActionBarNumSelected,
        tableActionBarNumTotal,
        currentSearchTermsScholarship,
        tableActionBarFunctionOpenExportTable = () => { },
        downloadTableActionBar,
        setDownloadTableActionBar,
        showActionBarSpinner,
        setActiveDonorSidebarTab = () => {}
    }) => {
    setActiveHeaderNav('programs');
    setActiveDonorSidebarTab("Applications")
    const router = useRouter();
    let getClassName=router.pathname==='/client/donations'
    const perPageCount = useSelector((state) => state.handleperPageCount)
    const dispatch = useDispatch()
    const { applications, persona_branding, scholarship, pagination, application_count_based_on_status, scholarshipId } = pageData;
    const [currentReviewers, setCurrentReviewers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemCountOnPage, setItemCountOnPage] = React.useState(perPageCount)
    // const [awardAmount, setAwardAmount] = useState(null)
    const [awardApplicationId, setAwardApplicationId] = useState()
    const [isOpenSweetAlert,setIsOpenSweetAlert]=useState(false)
    const [updateTable, setUpdateTable] = useState(false)
    const API = new KaleidoscopeAPI({});
    const { token, currentAccount: { sfid, enable_copyleaks_scan__c } } = accountData; 
    /**
     * Show the reviewers screen.
     * @returns {Promise<void>}
     */
    const showReviewersScreen = async () => {
        setLoading(true)
        router.push(MAIN_CONFIG.URLS.DONOR.SCHOLARSHIP_REVIEWERS(pageData.scholarshipId), undefined, { shallow: true })
        // setReviewersScreenState({ ...reviewersScreenState, visible: true, scholarshipId });
    }

    /**
     * Fetch reviewers for the current scholarship and set them
     * in the Review Screen state.
     * @returns {Promise<void>}
     */
    const getReviewersScreenData = async () => {
        setReviewersScreenState({
            ...reviewersScreenState,
            accountData,
            populateReviewers,
            data: currentReviewers,
            scholarshipId
        });
    };

    /**
     * Fetch reviewers.
     * @returns {Promise<void>}
     */
    const populateReviewers = async () => {
        setCurrentReviewers(
            await API.fetchReviewBoardMembers({
                token: accountData.token,
                accountId: accountData.currentAccount.sfid,
                scholarshipId
            })
        )
    }

    // Load reviewers in the background.
    useEffect(() => {
        populateReviewers();
        setShowApplicationsSidebar(true)
    }, []);

    // Update Reviewers Screen state if reviewers data changes
    useEffect(() => {
        getReviewersScreenData();
    }, [currentReviewers])

    let isElements = scholarship?.elements_review_board__c || false


    // Gather Scholarship table data
    const tableDataStatusCounts = application_count_based_on_status;
    const [rawTableData, setRawTableData] = useState(applications)
    const [statusUpdate, setStatusUpdate] = useState(false)
    const [awardUpdate,setAwardUpdate]=useState(false)
    const allTabData = persona_branding?.sub_tabs?.Applications;
    const filterTableHeader = (tab) => {
        
        let new__headers = tab.table_headers?.filter((header) => {
            if (isElements) {
                if (header.field_api_name__c !== 'Application_Total_Score__c') {
                    return header
                }
            } else {
                return header
            }
        })
        tab.table_headers = new__headers

        return tab
    }

    const updatedAllTabsData = allTabData?.map((tab) => {
        return filterTableHeader(tab)
    })
    // const rawTableData = applications;
    const rawTableDataProperty = 'applications';
    // const pageTitle = scholarship.name.toUpperCase();
    const pageTitle = scholarship?.name;
    const searchPlaceholder = 'Search applications';
    const ctaText = `${reviewersCount} Reviewers`;
    const ctaIcon = Globe;
    const ctaAction = showReviewersScreen;
    const tableDataFetch = async (options) => {
        return await API.fetchApplications({ token, accountId: sfid, scholarshipId, options })
    }
    const tableDataPostFetch = (tableData) => {
        // TODO: Determine why the property check is necessary to prevent error.
        return tableData[rawTableDataProperty] ? tableData[rawTableDataProperty] : [];
    }

    // Filter date for deadline

    const handleFilterDate = (convertDateNum) => {
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var date = new Date().getTime();
        date = date + (1000 * 60 * 60 * 24 * convertDateNum)
        var dateFilter = new Date(date)
        var result = monthNames[dateFilter.getMonth()] + " " + dateFilter.getDate();
        return result

    }

    /**
     * Attempts to normalize scholarship statuses for the InfoBar.
     * // TODO: Revisit this once proper statuses are worked out.
     * @param {object} scholarship
     * @returns {{ctaText: string, subtitle: *, useCtaAction: boolean, Icon: (function({id: *, className: *}): *), title: string}}
     */
    const getInfoBannerProps = (scholarship) => {
        let Icon, title, ctaText, useCtaAction = false, ctaAction = () => { };
        switch (scholarship.status__c) {
            case 'Accepting Applications':
                title = 'Open';
                Icon = Bolt;
                // const endDate = DateTime.local().plus({
                //     days: parseInt(scholarship.day_remaining__c.split(' ')[0], 10)
                // }).toFormat('LLL dd');
                // ctaText = `Deadline: ${endDate}`
                // const formattedDate = scholarship.deadline_date_time ? formatDeadlineDate(new Date(scholarship.deadline_date_time)) : '';
                ctaText = `Deadline: ${scholarship.deadline_date_time ? new Date(scholarship.deadline_date_time).toLocaleString(undefined, { day: '2-digit', month: 'short' }) : ''}`
                break;
            case 'Review Board':
                title = 'In Review';
                Icon = Eyes;
                ctaText = 'View Progress';
                useCtaAction = true;
                ctaAction = showReviewersScreen;
                break;
            case 'Closed':
                title = 'Awarded';
                Icon = Score;
        }

        return {
            title,
            subtitle: scholarship.status__c,
            Icon,
            ctaText,
            useCtaAction,
            ctaAction
        }
    }

    /**
     * Closes the modal.
     */
    const closeModal = () => {
        setModalState({ visible: false });
    }

    const handleModalActionClick = async (e, application) => {
        e.preventDefault();
        setModalState({
            visible: true,
            id: 'application-update-status',
            content: <ApplicationStatusChange handleClose={closeModal} application={application} handleUpdateApplicationStatus={handleUpdateApplicationStatus} />
        });
    }
    const handelAwardAmount = (e,application) => {
        e.preventDefault();
        setModalState({
            visible: true,
            id: 'application-update-award',
            content:<ApplicationAwardUpdate handleClose={closeModal}  application={application} onSubmit={onSubmit} />
        });
    }

    const closeAndRefreshTable = () => {
        setModalState({ visible: false });
        setUpdateTable(!updateTable)
    }

    const handleClickAlaskaAward = async  (e,application) => {
        e.preventDefault();
        if(application?.is_alaska_award_created){
            handleUpdateAlaskaAward(e,application)
        }
        else{
            handleViewAlaskaAward(e, application)
        }
    }

    const handleUpdateAlaskaAward = async (e, application) => {
        e.preventDefault();
        let result = await  API.fetchAlaskaAward({token, accountId: sfid, scholarshipId: application?.scholarship__c, applicationId: application?.sfid || application?.heroku_id__c})
        setModalState({
            visible: true,
            id: 'create-alaska-award-page',
            content: <UniversityOfAlaskaAward application={application} data={result} handleClose={closeModal} accountData={accountData} scholarship={scholarship} closeAndRefreshTable={closeAndRefreshTable} />
        });
    }

    const handleViewAlaskaAward = async (e, application) => {
        e.preventDefault();
        setModalState({
            visible: true,
            id: 'create-alaska-award-page',
            content: <UniversityOfAlaskaAward setLoading={setLoading} handleClose={closeModal}  application={application} accountData={accountData} closeAndRefreshTable={closeAndRefreshTable} />
        });
    }

    const handelScanResult = async (e,selectedApplication) => {
        e.preventDefault();

        // Track the "View" action
        const eventLabel = `Application: ${selectedApplication?.name}, userId: ${accountData?.user?.sfid}, accountId: ${accountData?.currentAccount?.sfid}`

        const dataLayerEvent = {
            event: 'View_AI_Plagiarism_Report',
            event_category: 'AI_Plagiarism_Scan',
            application_name: selectedApplication?.name,
            user_id: accountData?.user?.sfid,
            account_id: accountData?.currentAccount?.sfid,
            event_label: eventLabel,
            value: new Date().toISOString()
        };
        
        // Push data to Google Tag Manager's data layer
        TagManager.dataLayer({
            dataLayer: dataLayerEvent
        });
        
        setModalState({
            visible: true,
            id: 'application-scan-result',
            content: <ApplicationScanResult handleClose={closeModal} name={selectedApplication?.name} scanUrl={selectedApplication?.copyleaks_report_url__c} eventLabel={eventLabel} />
        });
    }

    const onSubmit = async(applicationId, awardAmount, scholarshipId, awardAmountNotes) => {
        setLoading(true)
        const response = await API.updateAwardAmount({ token: accountData.token,application: {award_amount__c: awardAmount, award_amount_notes__c :awardAmountNotes}, accountId: accountData.currentAccount.sfid, scholarshipId, applicationId: applicationId})
    if(response.success){
        toast.success(<FlashMessage message={response.message} />);
        setAwardUpdate(!awardUpdate)
        closeModal()
        setLoading(false)
    }
        else {
            toast.error(<FlashMessage type='error' message={response.message || 'some thing went wrong'} />);
        }
    }

    const getConfirmationBeforeRemove = (e,currentApplication) => {
        const alert = () => (
            <>
                <div className="save-changes-confirmation-alert modal-utility confirmation_modal">
                    <SweetAlert
                        showConfirm={true}
                        confirmBtnText="Okay"
                        showCancel={true}
                        cancelBtnText="Cancel"
                        customButtons={
                            <div className='action-footer'>
                                <button onClick={(e) => setIsOpenSweetAlert(false)} className='cta-button CTABlack cta-button__text'>Cancel</button>
                                <button onClick={(e) => {
                                    handleDeleteApplication(currentApplication);
                                }}
                                    className='cta-button CTAWhite tertiary cta-button__text'>Delete</button>
                            </div>
                        }
                        className=""
                    >
                        <div style={{ display: 'flex' }}>
                            <div>
                                <Alert />
                            </div>
                            <div className='content'>
                                <p className='title'>Are you sure you want to delete this application?</p>
                            </div>
                        </div>
                    </SweetAlert>
                </div>
            </>
        );
        setIsOpenSweetAlert(alert)
    }

    const handleDeleteApplication = async (selectedApplication) => {
        setIsOpenSweetAlert(false)
        setLoading(true)
        setUpdateTable(true)
        let response = await API.deleteApplication({
            token: accountData.token,
            accountId: accountData.currentAccount.sfid,
            scholarshipId: selectedApplication?.scholarship__c,
            applicationId: selectedApplication?.sfid
        });
        if(response.success){
            toast.success(<FlashMessage message={response.message || 'Application deleted'}/>);
        }
        else {
            toast.error(<FlashMessage type='error' message={response.message || 'some thing went wrong'} />);
        }
        setLoading(false)
        setUpdateTable(false)

    }

    /**
     * Returns the menu for a single scholarship in the scholarship table.
     * @param {object} scholarship
     * @returns {[{onClick: onClick, link: string, label: string}, {onClick: onClick, link: string, label: string}]}
     */
    const getRowMenu = (application) => {
        // TODO: Update the Duplicate action and support dynamic actions if required.
        let arg = [{ link: MAIN_CONFIG.URLS.DONOR.APPLICATION_SCCORE(pageData.scholarshipId, application.sfid ? application.sfid : application.heroku_id__c), onClick: () => { router.push(MAIN_CONFIG.URLS.DONOR.APPLICATION_SCCORE(pageData.scholarshipId, application.sfid ? application.sfid : application.heroku_id__c), undefined, { shallow: true }) }, label: 'View'}]
        if (enable_copyleaks_scan__c && application?.copyleaks_report_url__c) { // remove true before deployment 
        arg.push({ link: '#', onClick: (e) => handelScanResult(e,application), label: "View Scan Result" })
        }
        if (scholarship?.client_editable__c) {
            arg.push({ link: "#", onClick: (e) => handleModalActionClick(e, application), label: 'Update Status' })
        }
        if(application?.status__c==='Prototype'){
            arg.push({ link: "#", onClick: (e) => getConfirmationBeforeRemove(e, application), label: 'Delete Application' })
        }
        arg.push({ link: '#', onClick: (e) => handelAwardAmount(e,application), label: application.award_amount__c ? "Edit Award Amount" : "Add Award Amount" })
        if(scholarship.university_of_alaska_fund__c){
            arg.push({ link: '#', onClick: (e) => handleClickAlaskaAward(e,application), label: application.is_alaska_award_created ? "View Award Record" : "Create Award Record" })
        }
        return arg
    };

    const handleUpdateApplicationStatus = async (status, applicationId) => {

        let response = await API.updateApplicationStatus({ token: accountData.token, application: { status__c: status.value }, accountId: accountData.currentAccount.sfid, scholarshipId, applicationId })
        if (response.success) {
            toast.success(<FlashMessage message={response.message} />);
            setStatusUpdate(!statusUpdate)
            closeModal()
        } else {
            toast.error(<FlashMessage type='error' message={response.message} />);
            // setLoading(false)
        }
    }

    const clickTableDataView = (application) => {

        dispatch(backButtonClicked(false))

        setLoading(true)
        router.push(MAIN_CONFIG.URLS.DONOR.APPLICATION_SCCORE(pageData.scholarshipId, application.sfid ? application.sfid : application.heroku_id__c), undefined, { shallow: true })
        // window.location.href = MAIN_CONFIG.URLS.DONOR.APPLICATION_SCCORE(pageData.scholarshipId, application.sfid ? application.sfid : application.heroku_id__c)
    }

    return (
        <>
            <Loader loading={loading} />
            {/* <InfoBanner {...getInfoBannerProps(scholarship)} /> */}
            <TabbedTablePage
                rawTableData={rawTableData}
                tableDataFetch={tableDataFetch}
                tableDataPostFetch={tableDataPostFetch}
                allTabData={updatedAllTabsData}
                pageTitle={pageTitle}
                pagination={pagination}
                searchPlaceholder={searchPlaceholder}
                ctaIcon={ctaIcon}
                tableDataStatusCounts={tableDataStatusCounts}
                ctaText={ctaText}
                ctaAction={ctaAction}
                clickTableDataView={clickTableDataView}
                accountData={accountData}
                getRowMenu={getRowMenu}
                setShowTableActionBar={setShowTableActionBar}
                setTableActionBarNumSelected={setTableActionBarNumSelected}
                setSelectedRows={setSelectedRows}
                setRemoveRows={setRemoveRows}
                setSelectedRowsAll={setSelectedRowsAll}
                setTableActionBarNumTotal={setTableActionBarNumTotal}
                userContext={userContext}
                statusUpdate={statusUpdate}
                setStatusUpdate={setStatusUpdate}
                setCurrentSearchKeyScholarship={setCurrentSearchKeyScholarship}
                setCurrentSearchTermsScholarship={setCurrentSearchTermsScholarship}
                setActiveTabTable={setActiveTabTable}
                id='donor-scholarships-page' // TODO: Convert tabbed table styles to generic to avoid this specific id
                setItemCountOnPage={setItemCountOnPage}
                itemCountOnPage={itemCountOnPage}
                showRecordPerPage={pagination.totalRecords > 10}
                totalRecordsCount={pagination.totalRecords}
                scholarshipId={pageData.scholarshipId}
                bulkApplicationUpdate={true && scholarship?.client_editable__c ? true : false}
                showTableActionBar={showTableActionBar}
                page = {'applications'}
                awardUpdate={awardUpdate}
                tableActionBarNumSelected={tableActionBarNumSelected}
                tableActionBarNumTotal={tableActionBarNumTotal}
                currentSearchTermsScholarship={currentSearchTermsScholarship}
                tableActionBarFunctionOpenExportTable={tableActionBarFunctionOpenExportTable}
                pageType={pageType}
                downloadTableActionBar = {downloadTableActionBar}
                setDownloadTableActionBar = {setDownloadTableActionBar}
                showActionBarSpinner = {showActionBarSpinner}
                setModalState = {setModalState}
                pageData = {pageData}
                customClassName={getClassName?"excleOnly":''}
                updateTable={updateTable}
                handleClosePopup={closeModal}
                customtableHeaderClass={'scholorship-page_program-bar'}
            />
            {isOpenSweetAlert}
        </>
    );
}

DonorApplications.propTypes = {
    accountData: PropTypes.shape({
        token: PropTypes.string,
        currentAccount: PropTypes.shape({
            sfid: PropTypes.bool,
        }),
        user: PropTypes.shape({
            sfid: PropTypes.string,
        }),
    }),
    pageData: PropTypes.shape({
        scholarshipId: PropTypes.string,
    }),
    setActiveDonorSidebarTab: PropTypes.func
}

const DonorApplicationsPage = reduxPage(DonorApplications);

export default AppPage(DonorApplicationsPage);
